import React, { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Toolbar,
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { auth, storage } from "../Config/firebase";
import "./homeDashboard.css";
import { SIDEBAR_ITEMS } from "../Config/sidebarItems";
import { usePermissoesAcesso } from "../Utils/permissoesAcesso";
import QuickAccessBar from "../Components/QuickAccessBar";
import { collection, doc, getDoc, getDocs, limit, query, setDoc, where } from "firebase/firestore";
import { db } from "../Config/firebase";
import { useHistory } from "react-router-dom";
import { getUsuarioAtualComTenant, tenantWhere } from "../Utils/tenant";
import { temPermissaoRota } from "../../Hooks/temPermissaoRota";




import Sidebar from "./Sidebar";
import Navbar from "../Components/Navbar/navbar";
import DashboardContent from "./DashboardContent";
import SetAdminOnce from "../Utils/SetAdminOnce";

import SettingsIcon from "@mui/icons-material/Settings";
import { IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SyncIcon from "@mui/icons-material/Sync";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import { getDownloadURL, ref as storageRef, uploadBytes } from "firebase/storage";
import TutorialCadastro from "../Components/TutorialCadastro/TutorialCadastro";
import { ETAPAS_TUTORIAL_DASHBOARD } from "../Components/TutorialCadastro/etapasTutoriais";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";
import {
  createCategoria,
  createDocumento,
  createHistorico,
  getCategorias,
  getDocumentos,
} from "../SGQ/sgqService";


const drawerWidth = 260;

function getAllSidebarItems() {
  return Object.values(SIDEBAR_ITEMS)
    .flat()
    .flatMap(item => item.children ? [item, ...item.children] : [item])
    .filter(item => item.path); // só itens navegáveis
}

const SEARCH_SECTION_LABELS = {
  main: "Menu principal",
  cadastrar: "Cadastrar",
  admin: "Admin",
};

const NAVBAR_SEARCH_ITEMS = [
  { id: "pagina_principal", label: "Página Principal", path: "/dashboard", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar" },
  { id: "pagina_principal_qualidade", label: "Página Principal", path: "/app", tiposPermitidos: ["qualidade"], contexto: "Navbar" },
  { id: "os_interna", label: "O.S. interna", path: "/app/solicitacao-servicos", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar" },
  { id: "cadastrar_cliente", label: "Cadastrar Cliente", path: "/app/clientes", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar > Cadastrar" },
  { id: "sgq", label: "SGQ", path: "/sgq", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar" },
  { id: "etiquetas", label: "Etiquetas", path: "/app/GerarEtiquetas", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar" },
  { id: "responder_ocorrencias", label: "Responder Ocorrências", path: "/app/ocorrencias", tiposPermitidos: ["admin"], contexto: "Navbar > Ocorrências" },
  { id: "pagina_principal_cliente", label: "Página Principal", path: "/app/laudos", tiposPermitidos: ["cliente"], contexto: "Navbar" },
  { id: "cadastrar_obra_navbar", label: "Cadastrar Obra", path: "/app/cadastroobras", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar > Cadastrar" },
  { id: "cadastrar_concreteira_navbar", label: "Cadastrar Concreteira", path: "/app/cadastro-concreteiras", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar > Cadastrar" },
  { id: "ensaio_compactacao_navbar", label: "Ensaio Compactação", path: "/app/ensaio-compactacao", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar > Cadastrar > Ensaios" },
  { id: "ensaio_caracterizacao_navbar", label: "Ensaio Caracterização", path: "/app/cadastro-caracterizacao", tiposPermitidos: ["admin", "colaborador"], contexto: "Navbar > Cadastrar > Ensaios" },
  { id: "temperatura_tanque_navbar", label: "Temp. Tanque Cura", path: "/app/controle-temperatura-tanque-cura", tiposPermitidos: ["colaborador"], contexto: "Navbar" },
];

function getSearchableSidebarItems(dynamicItems = []) {
  const items = [];

  const addItems = (menuItems, parents = [], inheritedPermissions = {}) => {
    menuItems.forEach(item => {
      const permissions = {
        tiposPermitidos: item.tiposPermitidos ?? inheritedPermissions.tiposPermitidos,
        somenteAdminPrincipal:
          item.somenteAdminPrincipal ?? inheritedPermissions.somenteAdminPrincipal,
      };

      if (item.path) {
        items.push({
          ...item,
          ...permissions,
          contexto: parents.join(" > "),
        });
      }

      if (item.children?.length) {
        addItems(item.children, [...parents, item.label], permissions);
      }
    });
  };

  Object.entries(SIDEBAR_ITEMS).forEach(([section, sectionItems]) =>
    addItems(sectionItems, [SEARCH_SECTION_LABELS[section] || section])
  );
  items.push(...NAVBAR_SEARCH_ITEMS, ...dynamicItems);

  return Array.from(items.reduce((porRota, item) => {
    const existente = porRota.get(item.path);
    if (!existente) {
      porRota.set(item.path, { ...item, aliases: item.aliases || [] });
    } else {
      existente.aliases = [...existente.aliases, item.label, ...(item.aliases || [])];
      existente.contexto = `${existente.contexto || ""} ${item.contexto || ""}`.trim();
    }
    return porRota;
  }, new Map()).values());
}

function normalizeSearchText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

const QUICK_ACCESS_DEFAULT_LABELS = [
  "Agenda de Ruptura",
  "Ensaio RAA",
  "Materiais",
  "Obras",
  "Caixinha da Empresa",
  "Laudos",
];

const DOCUMENTOS_LISTA_MESTRA_COM_ROTA = [
  { codigo: "RQ 1.5", titulo: "Análise Crítica da Direção", categoria: "1", rota: "/app/analise-critica-direcao" },
  { codigo: "RQ 1.6", titulo: "Matriz de Riscos", categoria: "1", rota: "/app/matriz-riscos" },
  { codigo: "RQ 1.8", titulo: "Requisitos Legais", categoria: "1", rota: "/app/requisitos-legais" },
  { codigo: "RQ 1.13", titulo: "Planejamento de Recursos", categoria: "1", rota: "/app/planejamento-recursos" },
  { codigo: "RQ 2.2.6", titulo: "Índice de forma (método do paquímetro)", categoria: "2", rota: "/app/cadastro-caracterizacao" },
  { codigo: "RQ 2.2.7", titulo: "Extração de testemunho de estrutura de concreto", categoria: "2", rota: "/app/extracoes-testemunhos" },
  { codigo: "RQ 2.2.9", titulo: "Determinação da resistência de aderência à tração de revestimentos de argamassa", categoria: "2", rota: "/app/resistencia-tracao" },
  { codigo: "RQ 2.2.10", titulo: "Etiqueta padrão para CPs", categoria: "2", rota: "/app/GerarEtiquetas" },
  { codigo: "RQ 2.2.11", titulo: "Relatório de rupturas", categoria: "2", rota: "/app/agendamoldagem" },
  { codigo: "RQ 2.2.12", titulo: "Relatório de caracterização de agregados", categoria: "2", rota: "/app/relatorios/caracterizacao" },
  { codigo: "RQ 2.2.13", titulo: "Relatório de módulo de elasticidade", categoria: "2", rota: "/app/relatorios/modulo-elasticidade" },
  { codigo: "RQ 2.2.14", titulo: "Relatório de extrações de testemunho de concreto", categoria: "2", rota: "/app/extracoes-testemunhos" },
  { codigo: "RQ 2.2.17", titulo: "Relatório de Esclerometria", categoria: "2", rota: "/app/esclerometria" },
  { codigo: "RQ 2.2.15", titulo: "Relatório Paver", categoria: "2", rota: "/app/ruptura-paver" },
  { codigo: "RQ 2.2.16", titulo: "Relatório de arrancamento de revestimento", categoria: "2", rota: "/app/resistencia-tracao" },
  { codigo: "RQ 2.3.1", titulo: "Blocos de alvenaria", categoria: "2", rota: "/app/ruptura-bloco-ceramico" },
  { codigo: "RQ 2.3.3", titulo: "Relatório de blocos de alvenaria", categoria: "2", rota: "/app/ruptura-bloco-ceramico" },
  { codigo: "RQ 3.1.1", titulo: "Relatório de calibração da célula de carga", categoria: "3", rota: "/app/calibracao-prensa" },
  { codigo: "RQ 4.1.1", titulo: "Controle de equipamento de medição", categoria: "4", rota: "/app/cadastro-equipamentos" },
  { codigo: "RQ 4.2.1", titulo: "Controle de temperatura dos tanques", categoria: "4", rota: "/app/controle-temperatura-tanque-cura" },
  { codigo: "RQ 4.4", titulo: "Controle de Manutenção de Equipamentos", categoria: "4", rota: "/app/controle-manutencao-equipamentos" },
  { codigo: "RQ 5.9", titulo: "Programa de Treinamentos", categoria: "5", rota: "/app/programa-treinamentos" },
  { codigo: "RQ 6.4", titulo: "Proposta comercial", categoria: "6", rota: "/app/proposta-comercial" },
  { codigo: "RQ 8.1", titulo: "Fluxo de caixa", categoria: "8", rota: "/app/caixinha-empresa" },
  { codigo: "RQ 10.2", titulo: "Volume e Controle de Resíduos", categoria: "10", rota: "/app/controle-residuos" },
  { codigo: "RQ 11.1", titulo: "Laudo de dosagem de concreto", categoria: "11", rota: "/app/cadastro-dosagem" },
];

const CODIGOS_ADICIONAIS_PESQUISA_POR_ROTA = {
  "/lista-mestra": ["RQ 1.1"],
  "/app/analise-critica-direcao": ["POP 1.4"],
  "/app/planejamento-estrategico": ["RQ 1.4"],
  "/app/manual-qualidade": ["MQ 01"],
};

const ROTAS_ENSAIOS_NAVBAR = new Set([
  "/app/ensaio-raa",
  "/app/ensaio-compactacao",
  "/app/cadastro-caracterizacao",
  "/app/ensaio-argamassa",
  "/app/cadastro-dosagem",
]);

const ORDEM_GRUPOS_PESQUISA = [
  "Cadastros",
  "SGQ",
  "Ensaios",
  "Pesquisas e ocorrências",
  "Outros acessos",
  "Administração",
];

const CATEGORIAS_DOCUMENTOS_SGQ_PESQUISAVEIS = {
  10: "Programas de Prevenção",
  11: "Consultoria",
};

function formatarLabelPesquisa(item) {
  const codigosDosAliases = (item.aliases || []).filter(alias => /^(RQ|POP)\s*\d/i.test(alias));
  const codigosDaRota = DOCUMENTOS_LISTA_MESTRA_COM_ROTA
    .filter(documento => documento.rota === item.path)
    .map(documento => documento.codigo);
  const codigosAdicionais = CODIGOS_ADICIONAIS_PESQUISA_POR_ROTA[String(item.path || "").toLowerCase()] || [];
  const codigos = [...new Set([...codigosDosAliases, ...codigosDaRota, ...codigosAdicionais])];

  if (!codigos.length || codigos.some(codigo => normalizeSearchText(item.label).startsWith(normalizeSearchText(codigo)))) {
    return item.label;
  }

  return `${codigos.join(" / ")} — ${item.label}`;
}

function obterGrupoPesquisa(item) {
  const rota = String(item.path || "").toLowerCase();
  const contexto = String(item.contexto || "");
  const tiposPermitidos = Array.isArray(item.tiposPermitidos) ? item.tiposPermitidos : [];

  if (
    ROTAS_ENSAIOS_NAVBAR.has(rota) ||
    contexto.includes("Ensaios") ||
    ["concreto", "solos", "asfalto"].includes(item.categoria)
  ) {
    return "Ensaios";
  }

  if (contexto.includes("Pesquisa") || contexto.includes("Ocorrências")) {
    return "Pesquisas e ocorrências";
  }

  if (
    rota === "/sgq" ||
    rota.includes("lista-mestra") ||
    rota.includes("admin-sgq") ||
    tiposPermitidos.includes("qualidade") ||
    /^(RQ|POP|MQ)\s*\d/i.test(formatarLabelPesquisa(item))
  ) {
    return "SGQ";
  }

  if (contexto.startsWith("Admin")) return "Administração";
  if (contexto.includes("Cadastrar")) return "Cadastros";
  return "Outros acessos";
}

const TITULOS_CATEGORIAS_LISTA_MESTRA = {
  1: "MANUAL DA QUALIDADE",
  2: "ENSAIOS",
  3: "CALIBRAÇÃO",
  4: "LABORATÓRIO",
  5: "PESSOAS",
  6: "COMERCIAL",
  7: "AQUISIÇÕES",
  8: "FINANCEIRO",
  9: "VEÍCULOS",
  10: "PROGRAMAS SST E MA",
  11: "CONSULTORIA - PROJETOS DE DOSAGEM",
};

function normalizarCodigoISO(codigo) {
  const texto = String(codigo || "").trim().toUpperCase();
  const match = texto.match(/^(MQ|POP|RQ|DC)\s*(\d+(?:\.\d+)*)/);
  if (match) {
    const numero = match[2]
      .split(".")
      .map(parte => String(Number(parte)))
      .join(".");
    return `${match[1]}${numero}`;
  }
  return texto.replace(/\s+/g, "").replace(/\.+$/, "");
}

function slugifyListaMestra(texto) {
  return String(texto || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function extrairDadosPdfListaMestra(arquivo) {
  if (!arquivo || !/\.pdf$/i.test(arquivo.name)) return null;

  const nomeSemExtensao = arquivo.name.replace(/\.pdf$/i, "");
  const match = nomeSemExtensao.match(/^(MQ|POP|RQ|DC)[ _-]*(\d+(?:\.\d+)*)(.*)$/i);
  if (!match) return null;

  const sigla = match[1].toUpperCase();
  const numero = match[2]
    .split(".")
    .map(parte => String(Number(parte)))
    .join(".");
  const codigo = `${sigla} ${numero}`;
  const titulo = match[3]
    .replace(/^[ _-]+/, "")
    .replace(/[ _-]+/g, " ")
    .replace(/\[\d+\]$/, "")
    .trim() || codigo;

  return {
    arquivo,
    codigo,
    sigla,
    numero,
    titulo,
    categoria: numero.split(".")[0],
  };
}

function getDefaultQuickAccessIds() {
  return getAllSidebarItems()
    .filter(item => QUICK_ACCESS_DEFAULT_LABELS.includes(item.label))
    .map(item => item.id);
}

function itemPermitidoParaTipo(item, tipoUsuario, podeAcessarItem) {
  if (localStorage.getItem("planoUsuario") === "pessoal" && item.id === "usuarios") return false;
  const tipoPermitido = !Array.isArray(item.tiposPermitidos) || item.tiposPermitidos.includes(tipoUsuario);
  const principalPermitido = !item.somenteAdminPrincipal || podeAcessarItem(item);
  return tipoPermitido && principalPermitido;
}

function adicionarDias(data, dias) {
  const resultado = new Date(data);
  resultado.setDate(resultado.getDate() + dias);
  return resultado;
}

function formatarDataISO(data) {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}

function normalizarDataISO(data) {
  if (!data) return "";
  const valor = String(data);
  if (valor.includes("/")) {
    const [dia, mes, ano] = valor.split("/");
    return `${ano}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
  }
  return valor;
}

function gerarDatasLeituraRAA(dataMoldagem) {
  if (!dataMoldagem) return [];

  const [ano, mes, dia] = dataMoldagem.split("-").map(Number);
  if (!ano || !mes || !dia) return [];

  const dataBase = new Date(ano, mes - 1, dia);
  const leituraInicial = adicionarDias(dataBase, 1);
  const leituraDezesseisDias = adicionarDias(leituraInicial, 16);

  function proximasSegundasEQuintas(dataReferencia, quantidade, antesDe = null) {
    const datas = [];
    const cursor = adicionarDias(dataReferencia, 1);

    while (datas.length < quantidade) {
      if (antesDe && cursor >= antesDe) break;
      if (cursor.getDay() === 1 || cursor.getDay() === 4) {
        datas.push(new Date(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }

    return datas;
  }

  return [
    ...proximasSegundasEQuintas(leituraInicial, 4, leituraDezesseisDias),
    leituraDezesseisDias,
    ...proximasSegundasEQuintas(leituraDezesseisDias, 4),
  ].map(formatarDataISO);
}

function valorPreenchido(valor) {
  return valor !== null && valor !== undefined && String(valor).trim() !== "";
}

export default function HomeDashboard() {
  const { podeAcessarItem } = usePermissoesAcesso();
  /* ==========================
     RESPONSIVO
  ========================== */
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const tipoUsuario = String(localStorage.getItem("tipoUsuario") || "").toLowerCase();
  const history = useHistory();

  useEffect(() => {
  if (isMobile) {
    setSidebarOpen(false); // 📱 mobile → fechado
  } else {
    setSidebarOpen(true);  // 🖥️ desktop → aberto
  }
}, [isMobile]);


  /* ==========================
     STATE
  ========================== */
  const [claims, setClaims] = useState(null);
const [msg, setMsg] = useState("");
const [sidebarOpen, setSidebarOpen] = useState(false);
const [openTutorial, setOpenTutorial] = useState(false);
const [etapaInicial, setEtapaInicial] = useState(null);
const [importandoPdfsListaMestra, setImportandoPdfsListaMestra] = useState(false);
const [resultadoListaMestra, setResultadoListaMestra] = useState(null);
const inputPdfsListaMestraRef = useRef(null);


const toggleSidebar = () => {
  setSidebarOpen(prev => !prev);
};

const importarPdfsListaMestra = async (event) => {
  const arquivosSelecionados = Array.from(event.target.files || []);
  event.target.value = "";

  const documentosPorCodigo = new Map();
  let arquivosInvalidos = 0;
  arquivosSelecionados.forEach(arquivo => {
    const dados = extrairDadosPdfListaMestra(arquivo);
    if (!dados) {
      arquivosInvalidos += 1;
      return;
    }
    const codigoNormalizado = normalizarCodigoISO(dados.codigo);
    if (!documentosPorCodigo.has(codigoNormalizado)) {
      documentosPorCodigo.set(codigoNormalizado, dados);
    }
  });

  if (!documentosPorCodigo.size) {
    setResultadoListaMestra({
      severity: "warning",
      texto: "Nenhum PDF com código MQ, POP, RQ ou DC foi selecionado.",
    });
    return;
  }

  const confirmar = await confirmarSistema(
    `Deseja processar ${documentosPorCodigo.size} arquivo(s)? Formulários existentes no sistema serão cadastrados como link, e não como PDF. Códigos já cadastrados nunca serão substituídos.`
  );
  if (!confirmar) return;

  try {
    setImportandoPdfsListaMestra(true);
    setResultadoListaMestra(null);

    const [categorias, documentosExistentes] = await Promise.all([
      getCategorias(),
      getDocumentos(),
    ]);
    const categoriasPorCodigo = new Map(
      categorias.map(categoria => [String(categoria.codigo), categoria])
    );
    const codigosExistentes = new Set(
      documentosExistentes.map(documento => normalizarCodigoISO(documento.codigoISO))
    );
    const documentosComRotaPorCodigo = new Map(
      DOCUMENTOS_LISTA_MESTRA_COM_ROTA.map(documento => [
        normalizarCodigoISO(documento.codigo),
        documento,
      ])
    );
    const documentosLinksAusentes = DOCUMENTOS_LISTA_MESTRA_COM_ROTA.filter(
      documento => !codigosExistentes.has(normalizarCodigoISO(documento.codigo))
    );
    const documentosPdfAusentes = [...documentosPorCodigo.entries()]
      .filter(([codigoNormalizado]) => (
        !codigosExistentes.has(codigoNormalizado) &&
        !documentosComRotaPorCodigo.has(codigoNormalizado)
      ))
      .map(([, dados]) => dados);
    const ignoradosExistentes = [...documentosPorCodigo.keys()].filter(codigo => (
      codigosExistentes.has(codigo) && !documentosComRotaPorCodigo.has(codigo)
    )).length;
    const pdfsIgnoradosPorRota = [...documentosPorCodigo.keys()].filter(codigo => (
      documentosComRotaPorCodigo.has(codigo)
    )).length;

    const categoriasNecessarias = [
      ...new Set([
        ...documentosPdfAusentes.map(documento => documento.categoria),
        ...documentosLinksAusentes.map(documento => documento.categoria),
      ]),
    ];
    for (const codigoCategoria of categoriasNecessarias) {
      if (categoriasPorCodigo.has(codigoCategoria)) continue;

      const tituloCategoria = TITULOS_CATEGORIAS_LISTA_MESTRA[codigoCategoria];
      if (!tituloCategoria) {
        throw new Error(`Título não definido para a categoria ${codigoCategoria}.`);
      }
      const categoriaRef = await createCategoria({
        codigo: codigoCategoria,
        titulo: tituloCategoria,
      });
      categoriasPorCodigo.set(codigoCategoria, {
        id: categoriaRef.id,
        codigo: codigoCategoria,
        titulo: tituloCategoria,
      });
    }

    const dataEmissao = formatarDataISO(new Date());
    let linksCriados = 0;
    for (const documento of documentosLinksAusentes) {
      const [, numero] = documento.codigo.split(" ");
      const categoria = categoriasPorCodigo.get(documento.categoria);
      const docRef = await createDocumento({
        codigoISO: documento.codigo,
        codigoISOSigla: "RQ",
        codigoISONumero: numero,
        codigoISOOrder: numero.split(".").map(parte => parte.padStart(3, "0")).join("."),
        titulo: documento.titulo,
        categoriaCodigo: documento.categoria,
        categoriaTitulo: categoria.titulo,
        origemDocumento: "rota",
        rotaInterna: documento.rota,
        storagePath: "",
        revisaoAtual: "00",
        tipo: "Digital",
        dataEmissao,
        responsavel: "Silvio",
        status: "ativo",
        localArmazenamento: "Aplicação WEB",
        observacoes: "",
        dadosSensiveis: "nao",
        tipoDado: "Documento SGQ",
        justificativaTratamento: "",
        acessoRestrito: "nao",
        medidaProtecao: "Somente usuário logado",
      });

      await createHistorico({
        documentoId: docRef.id,
        codigoISO: documento.codigo,
        titulo: documento.titulo,
        storagePath: "",
        revisao: "00",
      });
      linksCriados += 1;
    }

    let importados = 0;
    for (const documento of documentosPdfAusentes) {
      const categoria = categoriasPorCodigo.get(documento.categoria);
      const basePath = `sgq/${slugifyListaMestra(categoria.titulo)}/${slugifyListaMestra(documento.codigo)}/${slugifyListaMestra(documento.titulo)}`;
      const caminhoAtual = `${basePath}/atual.pdf`;
      const caminhoRevisao = `${basePath}/rev-00.pdf`;

      await uploadBytes(storageRef(storage, caminhoAtual), documento.arquivo, {
        contentType: "application/pdf",
      });
      await uploadBytes(storageRef(storage, caminhoRevisao), documento.arquivo, {
        contentType: "application/pdf",
      });

      const docRef = await createDocumento({
        codigoISO: documento.codigo,
        codigoISOSigla: documento.sigla,
        codigoISONumero: documento.numero,
        codigoISOOrder: documento.numero.split(".").map(parte => parte.padStart(3, "0")).join("."),
        titulo: documento.titulo,
        categoriaCodigo: documento.categoria,
        categoriaTitulo: categoria.titulo,
        origemDocumento: "pdf",
        rotaInterna: "",
        storagePath: caminhoAtual,
        revisaoAtual: "00",
        tipo: "Digital",
        dataEmissao,
        responsavel: "Silvio",
        status: "ativo",
        localArmazenamento: "Aplicação WEB",
        observacoes: "",
        dadosSensiveis: "nao",
        tipoDado: "Documento SGQ",
        justificativaTratamento: "",
        acessoRestrito: "nao",
        medidaProtecao: "Somente usuário logado",
      });

      await createHistorico({
        documentoId: docRef.id,
        codigoISO: documento.codigo,
        titulo: documento.titulo,
        storagePath: caminhoRevisao,
        revisao: "00",
      });
      importados += 1;
    }

    setResultadoListaMestra({
      severity: "success",
      texto: `${linksCriados} link(s) criado(s); ${importados} PDF(s) importado(s); ${pdfsIgnoradosPorRota} PDF(s) de formulários ignorado(s); ${ignoradosExistentes} código(s) existente(s) ignorado(s); ${arquivosInvalidos} arquivo(s) inválido(s) ignorado(s).`,
    });
  } catch (error) {
    console.error("Erro ao importar PDFs da Lista Mestra:", error);
    setResultadoListaMestra({
      severity: "error",
      texto: error?.message || "Não foi possível importar os PDFs da Lista Mestra.",
    });
  } finally {
    setImportandoPdfsListaMestra(false);
  }
};


/* ⬇️ ESTE É O QUE FALTAVA ⬇️ */
const [quickAccessEnabled, setQuickAccessEnabled] = useState([]);

const [quickAccessLoaded, setQuickAccessLoaded] = useState(false);
const [contagensAcessoRapido, setContagensAcessoRapido] = useState({});
const [dynamicSearchItems, setDynamicSearchItems] = useState([]);
 
  
  /* ==========================
     CARREGAR CLAIMS
  ========================== */
  useEffect(() => {
    async function carregarClaims() {
      if (!auth.currentUser) return;

      const tokenResult = await auth.currentUser.getIdTokenResult(true);
      setClaims(tokenResult.claims);
    }

    carregarClaims();
  }, []);

  useEffect(() => {
    let cancelado = false;

    async function carregarRotasDinamicasDaNavbar() {
      if (!auth.currentUser || !tipoUsuario) return;

      const usuario = await getUsuarioAtualComTenant();
      if (usuario.isSuperadmin) return;

      const escoposPermitidos = tipoUsuario === "admin"
        ? ["colaborador", "cliente_colaborador"]
        : [tipoUsuario, "cliente_colaborador"];

      const consultas = [
        getDocs(query(
          collection(db, "kpis"),
          ...tenantWhere(usuario),
          where("ativo", "==", true),
          where("tipoKPI", "==", "PESQUISA"),
          where("escopo", "in", escoposPermitidos)
        )),
      ];

      const podeRegistrarOcorrencia = ["admin", "colaborador"].includes(tipoUsuario);
      if (podeRegistrarOcorrencia) {
        consultas.push(getDocs(query(
          collection(db, "kpis"),
          ...tenantWhere(usuario),
          where("ativo", "==", true),
          where("tipoKPI", "==", "EVENTO")
        )));
      }

      const [resultadosKpi, documentosSgq] = await Promise.all([
        Promise.all(consultas),
        ["admin", "colaborador"].includes(tipoUsuario) ? getDocumentos() : Promise.resolve([]),
      ]);
      const [pesquisasSnapshot, eventosSnapshot] = resultadosKpi;
      if (cancelado) return;

      const pesquisas = pesquisasSnapshot.docs
        .map(item => ({ id: item.id, ...item.data() }))
        .filter(item => item.tipoFormulario !== "PSICOSSOCIAL")
        .map(item => ({
          id: `pesquisa_${item.id}`,
          label: item.nome,
          path: `/app/pesquisa/${item.id}`,
          contexto: "Navbar > Pesquisa",
        }));

      const evento = eventosSnapshot?.docs[0];
      const documentosProgramasEConsultoria = documentosSgq
        .filter(documento => (
          documento.ativo !== false &&
          CATEGORIAS_DOCUMENTOS_SGQ_PESQUISAVEIS[String(documento.categoriaCodigo)]
        ))
        .map(documento => {
          const categoria = CATEGORIAS_DOCUMENTOS_SGQ_PESQUISAVEIS[String(documento.categoriaCodigo)];
          return {
            id: `documento_sgq_${documento.id}`,
            label: `${documento.codigoISO || "Documento"} — ${documento.titulo || "Sem título"}`,
            path: `documento-sgq:${documento.id}`,
            contexto: `Admin SGQ > ${documento.categoriaCodigo}. ${categoria}`,
            aliases: [categoria, documento.codigoISO, documento.titulo, documento.codigoISOSigla].filter(Boolean),
            tiposPermitidos: ["admin", "colaborador"],
            tipoResultado: "documento-sgq",
            origemDocumento: documento.origemDocumento,
            rotaInterna: documento.rotaInterna,
            storagePath: documento.storagePath,
          };
        });

      setDynamicSearchItems([
        ...documentosProgramasEConsultoria,
        ...pesquisas,
        ...(podeRegistrarOcorrencia ? [{
          id: "registrar_ocorrencias",
          label: "Registrar Ocorrências",
          path: evento ? `/kpi/evento/${evento.id}` : "/kpi/evento/indisponivel",
          contexto: "Navbar > Ocorrências",
        }] : []),
      ]);
    }

    carregarRotasDinamicasDaNavbar().catch(error => {
      console.error("Erro ao carregar rotas pesquisáveis da Navbar:", error);
      if (!cancelado) setDynamicSearchItems([]);
    });

    return () => {
      cancelado = true;
    };
  }, [tipoUsuario]);

  async function abrirResultadoPesquisa(item) {
    if (!item) return;

    if (item.tipoResultado !== "documento-sgq") {
      if (item.path) history.push(item.path);
      return;
    }

    if (item.origemDocumento === "rota" && item.rotaInterna) {
      if (!temPermissaoRota(item.rotaInterna, tipoUsuario)) {
        setMsg("Acesso negado. Você não possui permissão para acessar este documento.");
        return;
      }
      history.push(item.rotaInterna);
      return;
    }

    if (!item.storagePath) {
      setMsg("Este documento não possui um arquivo vinculado.");
      return;
    }

    try {
      const url = await getDownloadURL(storageRef(storage, item.storagePath));
      window.open(url, "_blank");
    } catch (error) {
      console.error("Erro ao abrir documento do SGQ pela pesquisa:", error);
      setMsg("Não foi possível abrir o documento selecionado.");
    }
  }

  useEffect(() => {
    async function verificarCadastrosIniciais() {
      if (!auth.currentUser) return;

      try {
        const usuario = await getUsuarioAtualComTenant();
        if (
          !usuario.tenantId ||
          usuario.isSuperadmin ||
          !["admin", "colaborador"].includes(usuario.tipo)
        ) return;

        const filtroTenant = where("tenantId", "==", usuario.tenantId);
        const [clientesSnapshot, obrasSnapshot] = await Promise.all([
          getDocs(query(collection(db, "clientes"), filtroTenant, limit(1))),
          getDocs(query(collection(db, "obras"), filtroTenant, limit(1))),
        ]);

        if (clientesSnapshot.empty) {
          setEtapaInicial("cliente");
        } else if (obrasSnapshot.empty) {
          setEtapaInicial("obra");
        }
      } catch (error) {
        console.error("Erro ao verificar cadastros iniciais:", error);
      }
    }

    verificarCadastrosIniciais();
  }, []);

  useEffect(() => {
    if (!auth.currentUser || claims === null) return;

    let cancelado = false;

    async function carregarContagensAcessoRapido() {
      try {
        const usuario = await getUsuarioAtualComTenant();
        const filtrosTenant = tenantWhere(usuario);
        const hoje = formatarDataISO(new Date());
        const inicioUltimos30Dias = new Date();
        inicioUltimos30Dias.setDate(inicioUltimos30Dias.getDate() - 30);
        const dataInicialRaa = formatarDataISO(inicioUltimos30Dias);
        const ensaiosRAASnapshot = await getDocs(
          query(collection(db, "tblEnsaioRAA"), ...filtrosTenant)
        );

        const ensaiosRAA = ensaiosRAASnapshot.docs.filter(
          (documento) => documento.data().cancelado !== true
        );
        const leiturasPorEnsaio = await Promise.all(
          ensaiosRAA.map((documento) =>
            getDocs(collection(db, "tblEnsaioRAA", documento.id, "leituras"))
          )
        );

        let leiturasRAAPendentes = 0;
        ensaiosRAA.forEach((documento, indiceEnsaio) => {
          const ensaio = documento.data();
          const datasSugeridas = gerarDatasLeituraRAA(ensaio.dataMoldagem);
          const leiturasSalvas = new Map(
            leiturasPorEnsaio[indiceEnsaio].docs.map((leitura) => [leitura.id, leitura.data()])
          );

          datasSugeridas.forEach((dataSugerida, indiceLeitura) => {
            const leitura = leiturasSalvas.get(String(indiceLeitura));
            const dataLeitura = normalizarDataISO(leitura?.data || dataSugerida);
            if (
              dataLeitura &&
              dataLeitura >= dataInicialRaa &&
              dataLeitura <= hoje &&
              !valorPreenchido(leitura?.media)
            ) {
              leiturasRAAPendentes += 1;
            }
          });
        });

        if (!cancelado) {
          setContagensAcessoRapido({
            raa: leiturasRAAPendentes,
          });
        }
      } catch (error) {
        console.error("Erro ao carregar pendências do acesso rápido:", error);
      }
    }

    carregarContagensAcessoRapido();
    return () => {
      cancelado = true;
    };
  }, [claims]);

        const isAdmin = claims?.admin === true;      
        const quickAccessItens = getAllSidebarItems()
          .filter(item => itemPermitidoParaTipo(item, tipoUsuario, podeAcessarItem))
          .filter(item => quickAccessEnabled.includes(item.id));

        const systemSearchItens = getSearchableSidebarItems(dynamicSearchItems)
          .filter(item => itemPermitidoParaTipo(item, tipoUsuario, podeAcessarItem))
          .map(item => ({ ...item, grupoPesquisa: obterGrupoPesquisa(item) }))
          .sort((itemA, itemB) => {
            const ordemA = ORDEM_GRUPOS_PESQUISA.indexOf(itemA.grupoPesquisa);
            const ordemB = ORDEM_GRUPOS_PESQUISA.indexOf(itemB.grupoPesquisa);
            if (ordemA !== ordemB) return ordemA - ordemB;
            return formatarLabelPesquisa(itemA).localeCompare(formatarLabelPesquisa(itemB), "pt-BR");
          });

          useEffect(() => {
                async function carregarQuickAccess() {
                  if (!auth.currentUser) return;

                  const ref = doc(db, "users", auth.currentUser.uid);
                  const snap = await getDoc(ref);

                  if (snap.exists() && Array.isArray(snap.data().quickAccess)) {
  const salvos = snap.data().quickAccess;
  const todosItens = getAllSidebarItems();
  const idsValidos = new Set(todosItens.map(i => i.id));

  const salvosValidos = salvos.filter(id => idsValidos.has(id));

  // 🔥 se estava tudo selecionado pelo padrão antigo, troca para o novo padrão
  if (salvosValidos.length === todosItens.length) {
    setQuickAccessEnabled(getDefaultQuickAccessIds());
  } else {
    setQuickAccessEnabled(salvosValidos);
  }
} else {
  setQuickAccessEnabled(getDefaultQuickAccessIds());
}

                  // ✅ MARCA COMO CARREGADO
                  setQuickAccessLoaded(true);
                }

                carregarQuickAccess();
              }, []);



           useEffect(() => {
                if (!quickAccessLoaded) return; // ⛔ NÃO salva antes de carregar

                async function salvarQuickAccess() {
                  if (!auth.currentUser) return;

                  try {
                    const ref = doc(db, "users", auth.currentUser.uid);
                    await setDoc(
                      ref,
                      { quickAccess: quickAccessEnabled },
                      { merge: true }
                    );
                  } catch (err) {
                    console.error("Erro ao salvar quickAccess:", err);
                  }
                }

                salvarQuickAccess();
              }, [quickAccessEnabled, quickAccessLoaded]);





  return (
    <Box className="dashboard-root">
      <Dialog open={Boolean(etapaInicial)} maxWidth="sm" fullWidth>
        <DialogTitle>Vamos iniciar!</DialogTitle>
        <DialogContent>
          {etapaInicial === "cliente" ? (
            <>
              <Box component="p" sx={{ mt: 0 }}>
                Para começar a utilizar o sistema, cadastre primeiro um cliente e depois uma obra.
              </Box>
              <Box component="p" sx={{ mb: 0 }}>
                Sempre que houver mais de um cliente ou mais de uma obra, cadastre todos eles. Assim, os ensaios ficam vinculados corretamente e mantêm sua rastreabilidade.
              </Box>
            </>
          ) : (
            <Box component="p" sx={{ m: 0 }}>
              Muito bem! Agora falta apenas cadastrar uma obra vinculada ao cliente. Depois desse passo, você poderá utilizar todo o sistema com a rastreabilidade correta dos ensaios.
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => history.push(
              etapaInicial === "cliente"
                ? "/app/clientes?novo=1&onboarding=1"
                : "/app/cadastroobras?novo=1&onboarding=1"
            )}
          >
            {etapaInicial === "cliente" ? "Cadastrar cliente" : "Cadastrar obra"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* SIDEBAR */}
             <Sidebar
                  open={sidebarOpen}
                  toggle={toggleSidebar}                />


      {/* ÁREA PRINCIPAL */}
      <Box
          component="main"
          className={`dashboard-main ${isMobile ? "mobile" : ""}`}
          sx={{
            ml: sidebarOpen && !isMobile ? `${drawerWidth}px` : 0,

            /* 🔥 ISSO RESOLVE O ESTOURO */
            width: sidebarOpen && !isMobile
              ? `calc(100vw - ${drawerWidth}px)`
              : "100vw",

            maxWidth: "100vw",
            overflowX: "hidden",

            transition: "margin-left 0.3s ease",
          }}
        >


        {/* NAVBAR */}
        <Box
        sx={{
          pl: "2px", // espaço para o botão do menu
          transition: "padding-left 0.3s ease",
        }}
      >
       
        <Navbar toggleSidebar={toggleSidebar} />

          

        

      </Box>



        {/* ESPAÇO DO NAVBAR */}
 


        {/* CONTEÚDO */}
       <Box
  className={`dashboard-content ${isMobile ? "compact" : ""}`}
  sx={{
    px: "10px",
  }}
>
  {/* 🔹 ACESSOS RÁPIDOS */}
  {!quickAccessLoaded ? (
    <Box sx={{ opacity: 0.5, pl: 2 }}>
      Carregando acessos rápidos...
    </Box>
  ) : (
    <Box
      sx={{
        position: "relative",
       
        px: "10px",
        py: 2,
        mt: 0,
        mb: 3,
        backgroundColor: "#fff",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Autocomplete
        options={systemSearchItens}
        autoHighlight
        clearOnEscape
        groupBy={item => item.grupoPesquisa}
        renderGroup={params => (
          <Box component="li" key={params.key}>
            <Box
              sx={{
                px: 2,
                py: 1,
                borderTop: "1px solid",
                borderColor: "divider",
                bgcolor: "grey.100",
                color: "text.secondary",
                fontSize: 12,
                fontWeight: 800,
                textTransform: "uppercase",
              }}
            >
              {params.group}
            </Box>
            <Box component="ul" sx={{ p: 0 }}>
              {params.children}
            </Box>
          </Box>
        )}
        getOptionLabel={item => formatarLabelPesquisa(item)}
        filterOptions={(options, state) => {
          const termos = normalizeSearchText(state.inputValue)
            .split(/\s+/)
            .filter(termo => termo && !["a", "as", "de", "do", "da", "dos", "das", "e"].includes(termo));

          if (!termos.length) return options;

          return options.filter(item => {
            const texto = normalizeSearchText(`${formatarLabelPesquisa(item)} ${item.contexto} ${item.id} ${(item.aliases || []).join(" ")}`);
            return termos.every(termo => texto.includes(termo));
          });
        }}
        onChange={(_, item) => abrirResultadoPesquisa(item)}
        noOptionsText="Nenhum acesso encontrado"
        renderOption={(props, item) => {
          const { key, ...optionProps } = props;
          const Icon = item.icon;
          return (
            <Box key={key} component="li" {...optionProps} sx={{ gap: 1.25 }}>
              {Icon && <Icon color="primary" fontSize="small" />}
              <Box>
                <Box sx={{ fontWeight: 600 }}>{formatarLabelPesquisa(item)}</Box>
                {item.contexto && (
                  <Box sx={{ color: "text.secondary", fontSize: 12 }}>
                    {item.contexto}
                  </Box>
                )}
              </Box>
            </Box>
          );
        }}
        renderInput={params => (
          <TextField
            {...params}
            size="small"
            placeholder="Pesquisar no sistema: qualificação, ensaio RAA, equipamentos..."
            aria-label="Pesquisar acessos do sistema"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <SearchIcon sx={{ color: "text.secondary", ml: 0.5, mr: 1 }} />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
        sx={{ mb: 2, maxWidth: 760 }}
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
          ml: 0.5,
        }}
      >
        <Box sx={{ fontSize: "12px", fontWeight: 600, color: "#1976d2" }}>
          Acesso rápido
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
          {tipoUsuario === "admin" && (
            <>
             
              <input
                ref={inputPdfsListaMestraRef}
                type="file"
                accept="application/pdf,.pdf"
                multiple
                webkitdirectory=""
                hidden
                onChange={importarPdfsListaMestra}
              />
             
            </>
          )}
        
          <Button
            variant="outlined"
            size="small"
            startIcon={<HelpOutlineIcon />}
            onClick={() => setOpenTutorial(true)}
          >
            Ver tutorial
          </Button>
          <Tooltip title="Configurar Dashboard">
            <IconButton
              size="small"
              aria-label="Configurar Dashboard"
              onClick={() => window.dispatchEvent(new Event("abrir-configuracao-dashboard"))}
            >
              <SettingsIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* CARROSSEL */}
      <QuickAccessBar
        itens={quickAccessItens}
        temPendencias={false}
        contagens={contagensAcessoRapido}
      />
    </Box>
  )}

  {msg && (
    <Alert
      severity={isAdmin ? "success" : "warning"}
      className="dashboard-alert"
    >
      {msg}
    </Alert>
  )}

  {resultadoListaMestra && (
    <Alert severity={resultadoListaMestra.severity} className="dashboard-alert">
      {resultadoListaMestra.texto}
    </Alert>
  )}

  <DashboardContent
    quickAccessEnabled={quickAccessEnabled}
    setQuickAccessEnabled={setQuickAccessEnabled}
    tipoUsuario={tipoUsuario}
  />
  <TutorialCadastro
    open={openTutorial}
    onClose={() => setOpenTutorial(false)}
    titulo="Tutorial — Tela inicial"
    etapas={ETAPAS_TUTORIAL_DASHBOARD}
  />
</Box>


      </Box>
    </Box>
    
  );
}
